import { faUser } from '@fortawesome/pro-solid-svg-icons';

import { Icon, MenuItem, Tag } from '@growtherapy/sprout-ui';

import { PUSH_DRAWER_ARIA_CONTROLS_ID } from '../constants';

export function ClientListDrawerControlMenuItem({
  isClientListDrawerOpen,
  onClickClientsButton,
  numberOfWaitingClients,
}: {
  isClientListDrawerOpen: boolean;
  onClickClientsButton: () => void;
  numberOfWaitingClients?: number;
}) {
  return (
    <MenuItem
      aria-controls={PUSH_DRAWER_ARIA_CONTROLS_ID}
      aria-expanded={isClientListDrawerOpen}
      onClick={onClickClientsButton}
      className='flex items-center gap-2'
    >
      <Icon aria-hidden icon={faUser} className='h-4 w-4' />
      <span className='sr-only'>
        {isClientListDrawerOpen ? 'Close' : 'Open'} clients
        {!!numberOfWaitingClients && ', '}
      </span>
      <span aria-hidden>Clients</span>
      {!!numberOfWaitingClients && (
        <>
          <Tag use='lilac'>{numberOfWaitingClients}</Tag>
          <span className='sr-only'>waiting</span>
        </>
      )}
    </MenuItem>
  );
}
